import { render, staticRenderFns } from "./SystemCurveItem.vue?vue&type=template&id=48ecf850&scoped=true&"
import script from "./SystemCurveItem.vue?vue&type=script&lang=js&"
export * from "./SystemCurveItem.vue?vue&type=script&lang=js&"
import style0 from "./SystemCurveItem.vue?vue&type=style&index=0&id=48ecf850&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48ecf850",
  null
  
)

export default component.exports